import { render, staticRenderFns } from "./ItemListPortfolioLayout.vue?vue&type=template&id=60a64763&scoped=true&"
import script from "./ItemListPortfolioLayout.vue?vue&type=script&lang=js&"
export * from "./ItemListPortfolioLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a64763",
  null
  
)

export default component.exports